import React, { useState } from 'react';
import { Tabs } from 'antd';
import Breadcrumbs from 'components/Breadcrumbs';
import SizeList from './sizes/SizeList';
import UniformItemList from './items/UniformItemList';
import PositionMappingList from './positions/PositionMappingList';
import WarehouseList from './warehouses/WarehouseList';
import { useUniformMgmt } from '../context/uniformMgmtContext';

const MastersDashboard = () => {
  const { activeTab, setActiveTab } = useUniformMgmt();

  const tabItems = [
    {
      key: 'items',
      label: 'Uniform Items',
      children: <UniformItemList />
    },
    {
      key: 'sizes',
      label: 'Sizes',
      children: <SizeList />
    },
    {
      key: 'positions',
      label: 'Position Mappings',
      children: <PositionMappingList />
    },
    {
      key: 'warehouses',
      label: 'Warehouses',
      children: <WarehouseList />
    }
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs maintitle="Uniform Management" />
        <div className="row">
          <div className="col-12">
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabItems}
              type="card"
              size="large"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MastersDashboard;
